<template>
  <div>
    <TheHeader />

    <section v-if="dadosAssociado.codsocio" id="relcontainer">
      <div class="container pb-5">
        <div class="row">
          <div class="col-12 py-4">
            <router-link class="btn-voltar d-print-none" :to="{ name: 'relatoriosaude' }">
              <span class="material-icons">chevron_left</span> Relatórios Planos
            </router-link>

            <h1 class="title mt-4 text-uppercase title-blue">
              RELATÓRIO DE COPARTICIPAÇÃO
            </h1>
          </div>

          <div class="message-box" v-if="this.urlParams.periodo == this.getCurrentYearAndMonth()">
            <img src="@/assets/img/megaphone.png" alt="Logo" class="report-logo">

            <div
              class="alert alert-warning border-0 d-flex align-items-center justify-content-between position-relative"
              role="alert">
              <p class="message">
                As Informações apresentadas neste relatório podem sofrer alterações no decorrer do mês.<br>
              </p>

              <p class="message" style="font-weight: bold;">
                O RELATÓRIO OFICIAL
              </p>

              <p class="message" style="font-weight: bold;">
                Será disponibilizado a partir do dia 25 do mês.
              </p>
            </div>
          </div>
        </div>

        <div class="row align-items-center mt-4">
          <div class="col-md-6">
            <div class="vidas-lista">
              <vue-select ref="selectVida" class="vue-select2" name="select2" :options="vidasLista" :searchable="true"
                placeholder="Selecione uma vida" language="pt" @input="buscarVida" @search="aoPesquisarVida"
                @open="aoAbrirSelectVida">
                <span slot="no-options"> Nenhum resultado. </span>
              </vue-select>
            </div>
          </div>

          <div class="col-md-6 mt-3 mt-md-0 text-md-right d-print-none d-flex flex-column align-items-md-end">
            <div class="d-flex flex-column gap-2">
              <button type="button" class="btn btn-outline-success font-weight-bold d-flex align-items-center justify-content-between"
                style="min-width: 175px;"
                :disabled="!temVidaSelecionada || modalEnvio.enviando" @click="baixarExcel">
                <span class="material-icons" style="font-size:16px;margin-right:8px;">mail_outline</span>
                ENVIAR EXCEL
              </button>

              <button type="button" class="btn btn-outline-danger font-weight-bold d-flex align-items-center justify-content-between"
                style="min-width: 175px;"
                :disabled="!temVidaSelecionada || modalEnvio.enviando" @click="baixarPDF">
                <span class="material-icons" style="font-size:16px;margin-right:8px;">mail_outline</span>
                ENVIAR PDF
              </button>
            </div>

            <small v-if="!temVidaSelecionada" class="text-muted mt-2">
              Selecione uma vida para liberar o envio do relatório.
            </small>
          </div>
        </div>

        <div v-if="Object.keys(vidas).length">
          <div class="bg-white rounded p-4 mt-4 border border-light">
            <div class="row">
              <div class="col-12">
                <div class="rel-title title-blue">ORGANIZAÇÃO</div>
                <div class="rel-value-reg">{{ dadosAssociado.entidade }}</div>
              </div>

              <div class="col-md-4 mt-4">
                <div class="rel-title title-blue">ASSOCIADO</div>
                <div class="rel-value-reg">{{ dadosAssociado.codsocio }}</div>
              </div>

              <div class="col-md-2 mt-4">
                <div class="rel-title title-blue">DATA DA FILIAÇÃO</div>
                <div class="rel-value-reg">{{ dadosAssociado.dtfiliacao }}</div>
              </div>

              <div class="col-md-6 mt-4">
                <div class="rel-title title-blue">ENDEREÇO</div>
                <div class="rel-value-reg">{{ dadosAssociado.endereco }}</div>
              </div>
            </div>
          </div>

          <div class="row" v-if="Object.keys(vidas).length > 1">
            <div class="col-md-4 mt-4" v-for="(item, index) in itemsTop" :key="index">
              <ItemCard ref="itemCard" :title="item.titulo" :value="String(item.valor)" />
            </div>
          </div>

          <div class="mt-5" v-if="resumoPorCategoria.length > 0">
            <h3 class="subtitle">RESUMO DE UTILIZAÇÕES</h3>

            <div class="bg-white p-0 mt-4 border border-light table-responsive">
              <table class="table table-resumo w-100 m-0">
                <thead>
                  <tr class="thead-blue">
                    <th scope="col" class="text-left" style="width: 40%;">Serviço</th>
                    <th scope="col" class="text-center" style="width: 20%;">QTD</th>
                    <th scope="col" class="text-center" style="width: 20%;">Subtotal</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, index) in resumoPorCategoria" :key="index">
                    <td class="text-left font-weight-bold" style="color: #004E9A; text-transform: uppercase;">
                      {{ item.tipo_servico || item.categoria }}
                    </td>
                    <td class="text-center">{{ item.quantidade_total || item.quantidade }}</td>
                    <td class="text-center">{{ (item.valor_total_cobrado || item.valor_total) | currency }}</td>
                  </tr>
                </tbody>

                <tfoot class="tfoot-light-blue">
                  <tr>
                    <td class="text-center pr-4 font-weight-bold">TOTAL</td>
                    <td class="text-center font-weight-bold">{{ totalResumo.quantidade_total || totalResumo.quantidade
                    }}</td>
                    <td class="text-center font-weight-bold">
                      {{ (totalResumo.valor_total_geral || totalResumo.valor_total) | currency }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div class="mt-5">

            <h3 class="subtitle">RELATÓRIO POR VIDAS</h3>

            <div class="mt-3 text-muted small">
              <p></p>
            </div>

            <div v-for="(grupo, grupoIndex) in gruposFamiliaSelecionados"
              :key="`grupo-${grupo.codSocio || 'socio'}-${grupo.codTitularResponsavel || grupoIndex}`"
              class="vida-grupo-shell grupo-familia-card">

              <div v-if="grupo.vidas.every(v => normalizarTipoDependencia(v) !== 'TITULAR')"
                class="vida-grupo-titular-label">
                TITULAR: {{ grupo.titularResponsavel || getNomeTitularGrupo(grupo) }}
              </div>

              <div v-for="(vida, i) in grupo.vidas"
                :key="`vida-${grupo.codTitularResponsavel || grupoIndex}-${vida.codvida || i}`"
                class="vida-table-shell">

                <div v-if="normalizarTipoDependencia(vida) === 'TITULAR' && i === 0"
                  class="vida-grupo-titular-label">
                  TITULAR | {{ vida.nome }}
                </div>

                <div v-if="normalizarTipoDependencia(vida) === 'DEPENDENTE' && (i === 0 || normalizarTipoDependencia(grupo.vidas[i - 1]) === 'TITULAR')"
                  class="vida-grupo-dependente-label">
                  DEPENDENTE(S):
                </div>

                <div class="vida-table-inner">
                  <div class="bg-vida-header px-3 py-2 d-flex justify-content-between align-items-center flex-wrap"
                    :class="{
                      'mt-2': i === 0,
                      'vida-header-colado': grupo.vidas.length > 1 && i > 0,
                      'bg-vida-header-titular': normalizarTipoDependencia(vida) === 'TITULAR',
                      'bg-vida-header-dependente': normalizarTipoDependencia(vida) === 'DEPENDENTE'
                    }">
                    <div class="font-weight-bold text-uppercase vida-header-text">
                      VIDA: {{ vida.nome }} | CARTEIRINHA: {{ vida.carteira }} | DT. VIGÊNCIA: {{ obterDtVigencia(vida)
                        || "-" }} | {{ normalizarTipoDependencia(vida) }}
                    </div>
                  </div>

                  <Lista class="bg-white pt-0 px-0 w-100 table-responsive lista-vida"
                    :items="filtrarVidas(vida.codvida)" />
                </div>
              </div>

              <div class="total-utilizacoes-titular-vidas">
                <div class="total-utilizacoes-titular-label">
                  TOTAL UTILIZAÇÕES TITULAR ({{ getNomeTitularGrupo(grupo) }})
                </div>

                <div class="total-utilizacoes-titular-valor">
                  {{ calcularTotalUtilizacoesGrupo(grupo).valorTotal | currency }}
                </div>
              </div>

            </div>

            <div class="mt-3 text-muted small">
              <p>* Esse relatório não possui validade para fins de Imposto de Renda.</p>
            </div>
          </div>


        </div>
      </div>
    </section>

    <section v-else class="py-5 text-center">
      <p class="text-muted font-weight-bold">Carregando dados...</p>
    </section>

    <div v-if="modalEnvio.visivel" class="modal-envio-backdrop">
      <div class="modal-envio-card">
        <div class="modal-envio-header">
          <h5>Envio de relatório</h5>

          <button type="button" class="modal-envio-close" :disabled="modalEnvio.enviando" @click="fecharModalEnvio">
            ×
          </button>
        </div>

        <div class="modal-envio-body">
          <p class="mb-2">
            O relatório será encaminhado para a caixa de e-mail cadastrada do associado.
          </p>

          <div class="mb-2 d-flex align-items-center flex-wrap">
            <span class="mr-1">E-mail de envio:</span>
            <template v-if="!editandoEmailEnvio">
              <strong class="mx-1">{{ emailEditavel || emailRelatorioEnvio || "E-mail não localizado" }}</strong>
              <span class="material-icons" style="font-size:18px;cursor:pointer;color:#004E9A;" @click="iniciarEdicaoEmail">edit</span>
            </template>
            <template v-else>
              <input v-model="emailEditavel" type="email" class="form-control form-control-sm mx-1" style="width:220px;" />
              <span class="material-icons" style="font-size:18px;cursor:pointer;color:#28a745;" title="Salvar" @click="salvarEmailEditavel">check</span>
              <span class="material-icons ml-1" style="font-size:18px;cursor:pointer;color:#dc3545;" title="Cancelar" @click="cancelarEdicaoEmail">close</span>
            </template>
          </div>

          <p class="mb-2">
            Tipo de arquivo:
            <strong>{{ modalEnvio.tipo === "pdf" ? "PDF" : "Excel" }}</strong>
          </p>

          <p class="mb-0">
            Vida selecionada:
            <strong>{{ vidaSelecionada ? vidaSelecionada.label : "-" }}</strong>
          </p>

          <div v-if="modalEnvio.erro" class="alert alert-danger mt-3 mb-0">
            {{ modalEnvio.erro }}
          </div>

          <div v-if="modalEnvio.sucesso" class="alert alert-success mt-3 mb-0">
            {{ modalEnvio.sucesso }}
          </div>
        </div>

        <div class="modal-envio-footer">
          <button type="button" class="btn btn-light font-weight-bold" :disabled="modalEnvio.enviando"
            @click="fecharModalEnvio">
            CANCELAR
          </button>

          <button type="button" class="btn btn-primary font-weight-bold"
            :disabled="modalEnvio.enviando || !!modalEnvio.sucesso" @click="confirmarEnvioRelatorio">
            {{ modalEnvio.enviando ? "ENVIANDO..." : "CONFIRMAR ENVIO" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<template>
  <div>
    <TheHeader />

    <section v-if="dadosAssociado.codsocio" id="relcontainer">
      <div class="container pb-5">
        <div class="row">
          <div class="col-12 py-4">
            <router-link class="btn-voltar d-print-none" :to="{ name: 'relatoriosaude' }">
              <span class="material-icons">chevron_left</span> Relatórios Planos
            </router-link>

            <h1 class="title mt-4 text-uppercase title-blue">
              RELATÓRIO DE COPARTICIPAÇÃO
            </h1>
          </div>

          <div class="message-box" v-if="this.urlParams.periodo == this.getCurrentYearAndMonth()">
            <img src="@/assets/img/megaphone.png" alt="Logo" class="report-logo">

            <div
              class="alert alert-warning border-0 d-flex align-items-center justify-content-between position-relative"
              role="alert">
              <p class="message">
                As Informações apresentadas neste relatório podem sofrer alterações no decorrer do mês.<br>
              </p>

              <p class="message" style="font-weight: bold;">
                O RELATÓRIO OFICIAL
              </p>

              <p class="message" style="font-weight: bold;">
                Será disponibilizado a partir do dia 25 do mês.
              </p>
            </div>
          </div>
        </div>

        <div class="row align-items-center mt-4">
          <div class="col-md-6">
            <div class="vidas-lista">
              <vue-select ref="selectVida" class="vue-select2" name="select2" :options="vidasLista" :searchable="true"
                placeholder="Selecione uma vida" language="pt" @input="buscarVida" @search="aoPesquisarVida"
                @open="aoAbrirSelectVida">
                <span slot="no-options"> Nenhum resultado. </span>
              </vue-select>
            </div>
          </div>

          <div class="col-md-6 mt-3 mt-md-0 text-md-right d-print-none d-flex flex-column align-items-md-end">
            <div class="d-flex flex-column gap-2">
              <button type="button" class="btn btn-outline-success font-weight-bold d-flex align-items-center justify-content-between"
                style="min-width: 210px;"
                :disabled="!temVidaSelecionada || modalEnvio.enviando" @click="baixarExcel">
                RELATÓRIO EM EXCEL
                <span class="material-icons" style="font-size:16px;margin-left:8px;">mail_outline</span>
              </button>

              <button type="button" class="btn btn-outline-danger font-weight-bold d-flex align-items-center justify-content-between"
                style="min-width: 210px;"
                :disabled="!temVidaSelecionada || modalEnvio.enviando" @click="baixarPDF">
                RELATÓRIO EM PDF
                <span class="material-icons" style="font-size:16px;margin-left:8px;">mail_outline</span>
              </button>
            </div>

            <small v-if="!temVidaSelecionada" class="text-muted mt-2">
              Selecione uma vida para liberar o envio do relatório.
            </small>
          </div>
        </div>

        <div v-if="Object.keys(vidas).length">
          <div class="bg-white rounded p-4 mt-4 border border-light">
            <div class="row">
              <div class="col-12">
                <div class="rel-title title-blue">ORGANIZAÇÃO</div>
                <div class="rel-value-reg">{{ dadosAssociado.entidade }}</div>
              </div>

              <div class="col-md-4 mt-4">
                <div class="rel-title title-blue">ASSOCIADO</div>
                <div class="rel-value-reg">{{ dadosAssociado.codsocio }}</div>
              </div>

              <div class="col-md-2 mt-4">
                <div class="rel-title title-blue">DATA DA FILIAÇÃO</div>
                <div class="rel-value-reg">{{ dadosAssociado.dtfiliacao }}</div>
              </div>

              <div class="col-md-6 mt-4">
                <div class="rel-title title-blue">ENDEREÇO</div>
                <div class="rel-value-reg">{{ dadosAssociado.endereco }}</div>
              </div>
            </div>
          </div>

          <div class="row" v-if="Object.keys(vidas).length > 1">
            <div class="col-md-4 mt-4" v-for="(item, index) in itemsTop" :key="index">
              <ItemCard ref="itemCard" :title="item.titulo" :value="String(item.valor)" />
            </div>
          </div>

          <div class="mt-5" v-if="resumoPorCategoria.length > 0">
            <h3 class="subtitle">RESUMO DE UTILIZAÇÕES</h3>

            <div class="bg-white p-0 mt-4 border border-light table-responsive">
              <table class="table table-resumo w-100 m-0">
                <thead>
                  <tr class="thead-blue">
                    <th scope="col" class="text-left" style="width: 40%;">Serviço</th>
                    <th scope="col" class="text-center" style="width: 20%;">QTD</th>
                    <th scope="col" class="text-center" style="width: 20%;">Subtotal</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, index) in resumoPorCategoria" :key="index">
                    <td class="text-left font-weight-bold" style="color: #004E9A; text-transform: uppercase;">
                      {{ item.tipo_servico || item.categoria }}
                    </td>
                    <td class="text-center">{{ item.quantidade_total || item.quantidade }}</td>
                    <td class="text-center">{{ (item.valor_total_cobrado || item.valor_total) | currency }}</td>
                  </tr>
                </tbody>

                <tfoot class="tfoot-light-blue">
                  <tr>
                    <td class="text-center pr-4 font-weight-bold">TOTAL</td>
                    <td class="text-center font-weight-bold">{{ totalResumo.quantidade_total || totalResumo.quantidade
                    }}</td>
                    <td class="text-center font-weight-bold">
                      {{ (totalResumo.valor_total_geral || totalResumo.valor_total) | currency }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div class="mt-5">

            <h3 class="subtitle">RELATÓRIO POR VIDAS</h3>

            <div class="mt-3 text-muted small">
              <p></p>
            </div>

            <div v-for="(grupo, grupoIndex) in gruposFamiliaSelecionados"
              :key="`grupo-${grupo.codSocio || 'socio'}-${grupo.codTitularResponsavel || grupoIndex}`"
              class="vida-grupo-shell grupo-familia-card">

              <div v-if="grupo.vidas.every(v => normalizarTipoDependencia(v) !== 'TITULAR')"
                class="vida-grupo-titular-label">
                TITULAR: {{ grupo.titularResponsavel || getNomeTitularGrupo(grupo) }}
              </div>

              <div v-for="(vida, i) in grupo.vidas"
                :key="`vida-${grupo.codTitularResponsavel || grupoIndex}-${vida.codvida || i}`"
                class="vida-table-shell">

                <div v-if="normalizarTipoDependencia(vida) === 'TITULAR' && i === 0"
                  class="vida-grupo-titular-label">
                  TITULAR | {{ vida.nome }}
                </div>

                <div v-if="normalizarTipoDependencia(vida) === 'DEPENDENTE' && (i === 0 || normalizarTipoDependencia(grupo.vidas[i - 1]) === 'TITULAR')"
                  class="vida-grupo-dependente-label">
                  DEPENDENTE(S):
                </div>

                <div class="vida-table-inner">
                  <div class="bg-vida-header px-3 py-2 d-flex justify-content-between align-items-center flex-wrap"
                    :class="{
                      'mt-2': i === 0,
                      'vida-header-colado': grupo.vidas.length > 1 && i > 0,
                      'bg-vida-header-titular': normalizarTipoDependencia(vida) === 'TITULAR',
                      'bg-vida-header-dependente': normalizarTipoDependencia(vida) === 'DEPENDENTE'
                    }">
                    <div class="font-weight-bold text-uppercase vida-header-text">
                      VIDA: {{ vida.nome }} | CARTEIRINHA: {{ vida.carteira }} | DT. VIGÊNCIA: {{ obterDtVigencia(vida)
                      || "-" }} | {{ normalizarTipoDependencia(vida) }}
                    </div>
                  </div>

                  <Lista class="bg-white pt-0 px-0 w-100 table-responsive lista-vida"
                    :items="filtrarVidas(vida.codvida)" />
                </div>
              </div>

              <div class="total-utilizacoes-titular-vidas">
                <div class="total-utilizacoes-titular-label">
                  TOTAL UTILIZAÇÕES TITULAR ({{ getNomeTitularGrupo(grupo) }})
                </div>

                <div class="total-utilizacoes-titular-valor">
                  {{ calcularTotalUtilizacoesGrupo(grupo).valorTotal | currency }}
                </div>
              </div>

            </div>

            <div class="mt-3 text-muted small">
              <p>* Esse relatório não possui validade para fins de Imposto de Renda.</p>
            </div>
          </div>


        </div>
      </div>
    </section>

    <section v-else class="py-5 text-center">
      <p class="text-muted font-weight-bold">Carregando dados...</p>
    </section>

    <div v-if="modalEnvio.visivel" class="modal-envio-backdrop">
      <div class="modal-envio-card">
        <div class="modal-envio-header">
          <h5>Envio de relatório</h5>

          <button type="button" class="modal-envio-close" :disabled="modalEnvio.enviando" @click="fecharModalEnvio">
            ×
          </button>
        </div>

        <div class="modal-envio-body">
          <p class="mb-2">
            O relatório será encaminhado para a caixa de e-mail cadastrada do associado.
          </p>

          <div class="mb-2 d-flex align-items-center flex-wrap">
            <span class="mr-1">E-mail de envio:</span>
            <template v-if="!editandoEmailEnvio">
              <strong class="mx-1">{{ emailEditavel || emailRelatorioEnvio || "E-mail não localizado" }}</strong>
              <span class="material-icons" style="font-size:18px;cursor:pointer;color:#004E9A;" @click="iniciarEdicaoEmail">edit</span>
            </template>
            <template v-else>
              <input v-model="emailEditavel" type="email" class="form-control form-control-sm mx-1" style="width:220px;" />
              <span class="material-icons" style="font-size:18px;cursor:pointer;color:#28a745;" title="Salvar" @click="salvarEmailEditavel">check</span>
              <span class="material-icons ml-1" style="font-size:18px;cursor:pointer;color:#dc3545;" title="Cancelar" @click="cancelarEdicaoEmail">close</span>
            </template>
          </div>

          <p class="mb-2">
            Tipo de arquivo:
            <strong>{{ modalEnvio.tipo === "pdf" ? "PDF" : "Excel" }}</strong>
          </p>

          <p class="mb-0">
            Vida selecionada:
            <strong>{{ vidaSelecionada ? vidaSelecionada.label : "-" }}</strong>
          </p>

          <div v-if="modalEnvio.erro" class="alert alert-danger mt-3 mb-0">
            {{ modalEnvio.erro }}
          </div>

          <div v-if="modalEnvio.sucesso" class="alert alert-success mt-3 mb-0">
            {{ modalEnvio.sucesso }}
          </div>
        </div>

        <div class="modal-envio-footer">
          <button type="button" class="btn btn-light font-weight-bold" :disabled="modalEnvio.enviando"
            @click="fecharModalEnvio">
            CANCELAR
          </button>

          <button type="button" class="btn btn-primary font-weight-bold"
            :disabled="modalEnvio.enviando || !!modalEnvio.sucesso" @click="confirmarEnvioRelatorio">
            {{ modalEnvio.enviando ? "ENVIANDO..." : "CONFIRMAR ENVIO" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import ItemCard from "@/components/relatorio/ItemCard";
import Lista from "@/components/relatorio/ListaUnimed";
// import IconPdf from "@/components/icones/Pdf";
import VueSelect from "vue-select";

import LogoCdlSaude from "@/assets/img/logo.png";

import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";

const REPORT_COLORS = {
  blue: "#004E9A",
  blueRgb: [0, 78, 154],

  lightBlue: "#EBF2F9",
  lightBlueRgb: [235, 242, 249],

  borderBlue: "#DBE9F7",
  borderBlueRgb: [219, 233, 247],

  textDark: "#222222",
  textDarkRgb: [34, 34, 34],

  white: "#FFFFFF",
  whiteRgb: [255, 255, 255],

  excelBlue: "FF004E9A",
  excelLightBlue: "FFEBF2F9",
  excelBorderBlue: "FFDBE9F7",
  excelWhite: "FFFFFFFF",
  excelDark: "FF222222",
  excelDependente: "FF546E7A"
};

const LOGO_CDL_SAUDE_PATH = LogoCdlSaude;

export default {
  name: "extrato-utilizacao-unimed",

  components: {
    VueSelect,
    TheHeader,
    ItemCard,
    Lista,
    // IconPdf
  },

  data() {
    return {
      total: 0,
      relData: [],
      vidas: {},
      dadosAssociado: {},
      agrupados: {},
      itemsTop: [],
      vidasLista: [],
      vidaSelecionada: null,
      pesquisandoVida: false,
      editandoEmailEnvio: false,
      emailEditavel: '',

      modalEnvio: {
        visivel: false,
        tipo: null,
        enviando: false,
        erro: "",
        sucesso: ""
      }
    };
  },

  filters: {
    filterData(val) {
      if (!val) return "";
      return val.replaceAll("/", "-");
    },

    currency(valor) {
      const formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      });

      return formatter.format(valor || 0);
    }
  },

  props: {
    tipo: String,
    periodo: String
  },

  computed: {
    urlParams() {
      return this.$route.params;
    },

    gruposFamiliaSelecionados() {
      if (!this.vidaSelecionada) return [];

      return this.montarGruposFamiliaNoFront();
    },

    temVidaSelecionada() {
      return !!this.vidaSelecionada;
    },

    emailRelatorioEnvio() {
      return this.obterEmailAssociadoEnvio();
    },

    vidasOrdenadas() {
      const lista = [];
      const adicionados = {};

      this.relData.forEach(item => {
        const codVida = String(this.getCodVidaValor(item) || "");

        if (codVida && this.vidas[codVida] && !adicionados[codVida]) {
          lista.push(this.vidas[codVida]);
          adicionados[codVida] = true;
        }
      });

      Object.values(this.vidas).forEach(vida => {
        const codVida = String(this.getCodVidaValor(vida) || vida.codvida || "");

        if (!adicionados[codVida]) {
          lista.push(vida);
          adicionados[codVida] = true;
        }
      });

      return lista;
    },

    resumoPorCategoria() {
      if (!this.relData || this.relData.length === 0) return [];

      const resumo = {};

      this.relData.forEach(item => {
        const nomeServico = item.descrservico || "Sem Categoria";
        const nomeServicoMaiusculo = String(nomeServico).toUpperCase();

        let categoriaAgrupada = nomeServicoMaiusculo;

        if (nomeServicoMaiusculo.includes("EXAME")) {
          categoriaAgrupada = "EXAMES";
        } else if (nomeServicoMaiusculo.includes("CONSULTA")) {
          categoriaAgrupada = "CONSULTAS";
        }

        const chaveGrupo = categoriaAgrupada;

        if (!resumo[chaveGrupo]) {
          resumo[chaveGrupo] = {
            categoria: categoriaAgrupada,
            quantidade: 0,
            valor_total: 0
          };
        }

        resumo[chaveGrupo].quantidade += item.quantidade || 1;
        resumo[chaveGrupo].valor_total += item.vlrtotal || 0;
      });

      return Object.values(resumo);
    },

    totalResumo() {
      return this.resumoPorCategoria.reduce(
        (acumulador, atual) => {
          acumulador.quantidade += atual.quantidade;
          acumulador.valor_total += atual.valor_total;
          return acumulador;
        },
        {
          quantidade: 0,
          valor_total: 0
        }
      );
    }
  },

  methods: {
    montarGruposFamiliaNoFront() {
      const registros = this.getRegistrosRelatorioPorSelecao();

      const gruposMap = {};
      const ordemGrupos = [];

      registros.forEach((item, index) => {
        const vida = this.montarVida(item);
        const chaveGrupo = this.getChaveGrupoFamilia(vida) || `vida_${vida.codvida || index}`;
        const codVida = String(vida.codvida || index);

        if (!gruposMap[chaveGrupo]) {
          gruposMap[chaveGrupo] = {
            codSocio:
              this.obterValorCampo(vida, [
                "codsocio",
                "codSocio",
                "CODSOCIO",
                "codcfo",
                "codCfo",
                "CODCFO"
              ]) ||
              this.dadosAssociado.codsocio ||
              "",
            codTitularResponsavel: this.getCodTitularVida(vida),
            titularResponsavel: this.getNomeTitularVida(vida),
            ordem: index,
            vidasMap: {},
            vidasOrdem: []
          };

          ordemGrupos.push(chaveGrupo);
        }

        if (!gruposMap[chaveGrupo].vidasMap[codVida]) {
          gruposMap[chaveGrupo].vidasMap[codVida] = vida;
          gruposMap[chaveGrupo].vidasOrdem.push(codVida);
        }

        if (this.normalizarTipoDependencia(vida) === "TITULAR") {
          gruposMap[chaveGrupo].titularResponsavel = vida.nome || this.getNomeTitularVida(vida);
        }
      });

      return ordemGrupos
        .map(chave => {
          const grupo = gruposMap[chave];
          const vidas = grupo.vidasOrdem.map(codVida => grupo.vidasMap[codVida]);

          return {
            codSocio: grupo.codSocio,
            codTitularResponsavel: grupo.codTitularResponsavel,
            titularResponsavel: grupo.titularResponsavel,
            ordem: grupo.ordem,
            vidas: vidas.sort((a, b) => {
              const ordemA = this.normalizarTipoDependencia(a) === "TITULAR" ? 0 : 1;
              const ordemB = this.normalizarTipoDependencia(b) === "TITULAR" ? 0 : 1;

              if (ordemA !== ordemB) return ordemA - ordemB;

              return String(a.nome || "").localeCompare(String(b.nome || ""));
            })
          };
        })
        .filter(grupo => grupo.vidas.length > 0);
    },

    getRegistrosRelatorioPorSelecao() {
      if (!this.vidaSelecionada || String(this.vidaSelecionada.value) === "0") {
        return this.relData;
      }

      const codVidaSelecionada = String(this.vidaSelecionada.value);
      const registroSelecionado = this.relData.find(
        item => String(this.getCodVidaValor(item)) === codVidaSelecionada
      );

      if (!registroSelecionado) {
        return [];
      }

      const vidaSelecionada = this.montarVida(registroSelecionado);
      const tipoSelecionado = this.normalizarTipoDependencia(vidaSelecionada);

      if (tipoSelecionado !== "TITULAR") {
        return this.relData.filter(
          item => String(this.getCodVidaValor(item)) === codVidaSelecionada
        );
      }

      const chaveGrupoTitular = this.getChaveGrupoFamilia(vidaSelecionada);

      return this.relData.filter(item => {
        const vida = this.montarVida(item);

        return this.getChaveGrupoFamilia(vida) === chaveGrupoTitular;
      });
    },

    obterValorCampo(item, nomes) {
      if (!item) return "";

      for (const nome of nomes) {
        if (item[nome] !== undefined && item[nome] !== null) {
          return item[nome];
        }
      }

      const normalizarChave = valor =>
        String(valor)
          .replace(/_/g, "")
          .toLowerCase();

      const chavesItem = Object.keys(item);

      for (const nome of nomes) {
        const chaveNormalizada = normalizarChave(nome);
        const chaveEncontrada = chavesItem.find(
          chave => normalizarChave(chave) === chaveNormalizada
        );

        if (
          chaveEncontrada &&
          item[chaveEncontrada] !== undefined &&
          item[chaveEncontrada] !== null
        ) {
          return item[chaveEncontrada];
        }
      }

      return "";
    },

    obterDtVigencia(item) {
      const valor = this.obterValorCampo(item, [
        "dtVigencia",
        "dt_VIGENCIA",
        "DT_VIGENCIA",
        "dtvigencia",
        "DTVIGENCIA",
        "dtinclusao",
        "DTINCLUSAO",
        "dataVigencia",
        "DATA_VIGENCIA"
      ]);

      return this.formatarDataBrasil(valor);
    },

    formatarDataBrasil(valor) {
      if (!valor) return "";

      if (valor instanceof Date && !Number.isNaN(valor.getTime())) {
        const dia = String(valor.getDate()).padStart(2, "0");
        const mes = String(valor.getMonth() + 1).padStart(2, "0");
        const ano = valor.getFullYear();

        return `${dia}/${mes}/${ano}`;
      }

      const texto = String(valor).trim();

      if (!texto || texto === "1900-01-01" || texto.startsWith("1900-01-01")) {
        return "";
      }

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(texto)) {
        return texto;
      }

      const matchIso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/);

      if (matchIso) {
        return `${matchIso[3]}/${matchIso[2]}/${matchIso[1]}`;
      }

      const data = new Date(texto);

      if (!Number.isNaN(data.getTime())) {
        const dia = String(data.getDate()).padStart(2, "0");
        const mes = String(data.getMonth() + 1).padStart(2, "0");
        const ano = data.getFullYear();

        return `${dia}/${mes}/${ano}`;
      }

      return texto;
    },

    normalizarTextoComparacao(valor) {
      return String(valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toUpperCase();
    },

    getCodVidaValor(item) {
      return this.obterValorCampo(item, [
        "codvida",
        "codVida",
        "CODVIDA",
        "cod_vida",
        "COD_VIDA"
      ]);
    },

    getNomeVida(item) {
      return this.obterValorCampo(item, [
        "nome",
        "Nome",
        "vida",
        "Vida",
        "VIDA",
        "pf",
        "PF"
      ]);
    },

    getCodTitularVida(item) {
      return this.obterValorCampo(item, [
        "CODTITULAR_RESPONSAVEL",
        "codtitular_RESPONSAVEL",
        "codTitularResponsavel",
        "CodTitularResponsavel",
        "codtitularresponsavel",
        "CODTITULARRESPONSAVEL",
        "codTitular",
        "codtitular",
        "CODTITULAR",
        "cod_titular",
        "COD_TITULAR",
        "codTitular_Relacao",
        "CODTITULAR_RELACAO"
      ]);
    },

    getNomeTitularVida(item) {
      const valorDireto = this.obterValorCampo(item, [
        "TITULAR_RESPONSAVEL",
        "titular_RESPONSAVEL",
        "titulaR_RESPONSAVEL",
        "titularResponsavel",
        "TitularResponsavel",
        "titularresponsavel",
        "TITULARRESPONSAVEL",
        "nomeTitular",
        "NOME_TITULAR",
        "nome_TITULAR",
        "titular"
      ]);

      if (valorDireto) return valorDireto;

      const chaves = Object.keys(item || {});
      const chaveEncontrada = chaves.find(chave => {
        const chaveNormalizada = this.normalizarTextoComparacao(chave).replace(/_/g, "");

        return (
          chaveNormalizada.includes("TITULAR") &&
          (
            chaveNormalizada.includes("RESPONSAVEL") ||
            chaveNormalizada.includes("RESP")
          )
        );
      });

      return chaveEncontrada ? item[chaveEncontrada] : "";
    },

    getChaveGrupoFamilia(item) {
      const codSocio =
        this.obterValorCampo(item, [
          "codsocio",
          "codSocio",
          "CODSOCIO",
          "codcfo",
          "codCfo",
          "CODCFO"
        ]) ||
        this.dadosAssociado.codsocio ||
        "";

      const nomeTitular = this.normalizarTextoComparacao(this.getNomeTitularVida(item));

      if (nomeTitular) {
        return `${codSocio}_TITULAR_RESPONSAVEL_${nomeTitular}`;
      }

      const codTitular = this.getCodTitularVida(item);

      if (codTitular) {
        return `${codSocio}_COD_TITULAR_${codTitular}`;
      }

      return `${codSocio}_VIDA_${this.getCodVidaValor(item) || item.codvida}`;
    },

    normalizarTipoDependencia(item) {
      const nomeTitular = this.normalizarTextoComparacao(this.getNomeTitularVida(item));
      const nomeVida = this.normalizarTextoComparacao(this.getNomeVida(item));

      if (nomeTitular && nomeVida) {
        return nomeTitular === nomeVida ? "TITULAR" : "DEPENDENTE";
      }

      const valor = this.obterValorCampo(item, [
        "tipO_DEPENDENCIA",
        "tipo_DEPENDENCIA",
        "tipoDependencia",
        "tipo_dependencia",
        "tipodependencia",
        "TIPO_DEPENDENCIA",
        "TipoDependencia",
        "Tipo_Dependencia",
        "tipoDep",
        "tipo_dep"
      ]);

      const tipo = String(valor || "").trim().toUpperCase();

      if (!tipo) return "NÃO INFORMADO";
      if (tipo.includes("TITULAR")) return "TITULAR";

      return "DEPENDENTE";
    },

    normalizarRegistroApi(item) {
      const registro = { ...item };

      const codvida = this.getCodVidaValor(registro) || registro.codvida;
      const nome = this.getNomeVida(registro) || registro.nome || registro.pf;
      const carteira =
        registro.numcarteira ||
        registro.numCarteira ||
        registro.NUMCARTEIRA ||
        registro.carteira;

      const titularResponsavel = this.getNomeTitularVida(registro);
      const codTitularResponsavel = this.getCodTitularVida(registro);

      const normalizado = {
        ...registro,
        codvida,
        pf: nome,
        nome,
        numcarteira: carteira,
        carteira,
        titularResponsavel,
        titulaR_RESPONSAVEL: titularResponsavel,
        TITULAR_RESPONSAVEL: titularResponsavel,
        codTitularResponsavel,
        CODTITULAR_RESPONSAVEL: codTitularResponsavel
      };

      return {
        ...normalizado,
        tipoDependencia: this.normalizarTipoDependencia(normalizado)
      };
    },

    montarVida(item) {
      const vida = {
        ...item,
        codvida: this.getCodVidaValor(item) || item.codvida,
        nome: this.getNomeVida(item) || item.nome,
        carteira: item.numcarteira || item.numCarteira || item.NUMCARTEIRA || item.carteira,
        codTitularResponsavel: this.getCodTitularVida(item),
        titularResponsavel: this.getNomeTitularVida(item),
        dtVigencia: this.obterDtVigencia(item),
        tipO_DEPENDENCIA: item.tipO_DEPENDENCIA
      };

      return {
        ...vida,
        tipoDependencia: this.normalizarTipoDependencia(vida)
      };
    },

    getNomeTitularGrupo(grupo) {
      const primeiraVida = grupo && grupo.vidas && grupo.vidas.length ? grupo.vidas[0] : {};

      return String(
        (grupo && grupo.titularResponsavel) ||
        this.getNomeTitularVida(primeiraVida) ||
        primeiraVida.nome ||
        primeiraVida.pf ||
        "NÃO INFORMADO"
      ).toUpperCase();
    },

    calcularTotalUtilizacoesGrupo(grupo) {
      if (!grupo || !grupo.vidas) {
        return {
          quantidade: 0,
          valorTotal: 0
        };
      }

      return grupo.vidas.reduce(
        (acumulador, vida) => {
          this.filtrarVidas(vida.codvida).forEach(uso => {
            acumulador.quantidade += Number(uso.quantidade) || 1;
            acumulador.valorTotal += Number(uso.vlrtotal) || 0;
          });

          return acumulador;
        },
        {
          quantidade: 0,
          valorTotal: 0
        }
      );
    },

    getRelatorio() {
      this.$http
        .get(`/api/CdlBh/RelatorioExtratoUtilizacaoCoParUnimed?AnoMes=${this.urlParams.periodo}`)
        .then(response => {
          const coparticipacao = response.data.coparticipacao || [];

          this.relData = coparticipacao.map(item =>
            this.normalizarRegistroApi(item)
          );

          this.dadosAssociado = response.data || {};

          this.relData.forEach(el => {
            const temVida = this.vidasLista.filter(vida => vida.value == el.codvida);

            if (temVida.length === 0) {
              const tipoDep = this.normalizarTipoDependencia(el);
              const labelVida = tipoDep === 'TITULAR'
                ? `${el.pf} - (Titular)`
                : `${el.pf} (Dependente) - Titular: ${this.getNomeTitularVida(el) || ''}`;
              this.vidasLista.push({
                label: labelVida,
                value: el.codvida
              });
            }
          });

          this.vidasLista.unshift({
            label: "TODOS",
            value: 0
          });
        })
        .then(() => {
          this.total = 0;

          this.relData.forEach(el => {
            this.total += el.vlrtotal || 0;
          });
        })
        .then(() => {
          this.itemsTop = [
            {
              titulo: "Período",
              valor: this.formatDate(this.urlParams.periodo)
            }
          ];
        })
        .catch(error => {
          console.error(error);
        });
    },

    addTitleBluePdf(doc, y, margin, text, fontSize = 11) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(fontSize);
      doc.setTextColor(...REPORT_COLORS.blueRgb);

      doc.text(String(text).toUpperCase(), margin, y + 15);

      return y + 25;
    },

    getCurrentYearAndMonth() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const formattedMonth = month < 10 ? `0${month}` : month;

      return `${year}-${formattedMonth}`;
    },

    filtrarVidas(codvida) {
      const registrosVida = this.relData.filter(el => el.codvida === codvida);
      const agrupados = {};

      registrosVida.forEach(item => {
        const nomeServico = item.descrservico || "Sem Categoria";
        const vlrUnitario = item.vlrunitario || 0;
        const dataAtendimento = item.dtatendimento || item.data || "";
        const chaveGrupo = `${dataAtendimento}_${nomeServico}_${vlrUnitario}`;

        if (!agrupados[chaveGrupo]) {
          agrupados[chaveGrupo] = {
            ...item,
            quantidade: item.quantidade || 1
          };
        } else {
          agrupados[chaveGrupo].quantidade += item.quantidade || 1;
          agrupados[chaveGrupo].vlrtotal += item.vlrtotal || 0;
        }
      });

      return Object.values(agrupados);
    },

    aoPesquisarVida(search) {
      this.pesquisandoVida = !!String(search || "").trim();
    },

    aoAbrirSelectVida() {
      this.pesquisandoVida = false;
    },

    buscarVida(prop) {
      this.pesquisandoVida = false;
      this.vidas = {};
      this.vidaSelecionada = prop || null;

      if (!prop) return;

      const registros = this.getRegistrosRelatorioPorSelecao();

      registros.forEach(item => {
        const vida = this.montarVida(item);

        if (vida && vida.codvida) {
          this.$set(this.vidas, vida.codvida, vida);
        }
      });
    },

    formatDate(date) {
      const ano = date.substr(0, 4);
      const mes = this.getMes(date.substr(5, 2));

      return `${mes} / ${ano}`;
    },

    getMes(mes) {
      const m = parseInt(mes) - 1;
      return this.$store.state.calendarOpts.pt.monthNames[m];
    },

    baixarPDF() {
      this.abrirModalEnvio("pdf");
    },

    baixarExcel() {
      this.abrirModalEnvio("excel");
    },

    abrirModalEnvio(tipo) {
      if (!this.temVidaSelecionada) return;

      this.modalEnvio = {
        visivel: true,
        tipo,
        enviando: false,
        erro: "",
        sucesso: ""
      };
    },

    iniciarEdicaoEmail() {
      this.emailEditavel = this.emailRelatorioEnvio || '';
      this.editandoEmailEnvio = true;
    },

    salvarEmailEditavel() {
      this.editandoEmailEnvio = false;
    },

    cancelarEdicaoEmail() {
      this.emailEditavel = '';
      this.editandoEmailEnvio = false;
    },

    fecharModalEnvio() {
      if (this.modalEnvio.enviando) return;

      this.modalEnvio = {
        visivel: false,
        tipo: null,
        enviando: false,
        erro: "",
        sucesso: ""
      };
    },

    async confirmarEnvioRelatorio() {
      if (!this.temVidaSelecionada) {
        this.modalEnvio.erro = "Selecione uma vida para enviar o relatório.";
        return;
      }

      try {
        this.modalEnvio.enviando = true;
        this.modalEnvio.erro = "";
        this.modalEnvio.sucesso = "";

        const arquivo = this.modalEnvio.tipo === "pdf"
          ? await this.gerarPdfBlob()
          : await this.gerarExcelBlob();

        const response = await this.enviarRelatorioPorEmail({
          blob: arquivo.blob,
          nomeArquivo: arquivo.nomeArquivo,
          tipo: this.modalEnvio.tipo
        });

        const dadosResposta = response && response.data ? response.data : {};

        const emailEnviado =
          dadosResposta.emailEnviado ||
          dadosResposta.EmailEnviado ||
          dadosResposta.email ||
          "";

        this.modalEnvio.sucesso = emailEnviado
          ? `Relatório enviado com sucesso para o e-mail ${emailEnviado}.`
          : "Relatório enviado com sucesso para o e-mail cadastrado.";
      } catch (error) {
        console.error(error);

        this.modalEnvio.erro =
          error && error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Não foi possível enviar o relatório por e-mail.";
      } finally {
        this.modalEnvio.enviando = false;
      }
    },

    async enviarRelatorioPorEmail({ blob, nomeArquivo, tipo }) {
      const dadosExportacao = this.getDadosAssociadoExportacao();
      const formData = new FormData();

      formData.append("arquivo", blob, nomeArquivo);
      formData.append("tipo", tipo);
      formData.append("periodo", this.urlParams.periodo || "");
      formData.append("codSocio", dadosExportacao.codSocio || "");
      formData.append("nomeAssociado", dadosExportacao.nomeComercial || "");
      formData.append("emailAssociado", this.emailEditavel || this.emailRelatorioEnvio || "");
      formData.append("vidaSelecionada", this.vidaSelecionada ? this.vidaSelecionada.label : "");
      formData.append("codVida", this.vidaSelecionada ? this.vidaSelecionada.value : "");

      return this.$http.post(
        "/api/CdlBh/EnviarRelatorioCoparticipacaoEmail",
        formData
      );
    },

    obterEmailAssociadoEnvio() {
      const cadastro =
        this.$user && this.$user.dadosCadastraisAssociado
          ? this.$user.dadosCadastraisAssociado[0] || {}
          : {};

      const emailCadastro = this.obterValorCampo(cadastro, [
        "email"
      ]);

      if (emailCadastro) return emailCadastro;

      return this.obterValorCampo(this.dadosAssociado, [
        "email"
      ]);
    },

    getDadosAssociadoExportacao() {
      const cadastro =
        this.$user && this.$user.dadosCadastraisAssociado
          ? this.$user.dadosCadastraisAssociado[0] || {}
          : {};

      return {
        codSocio: cadastro.codsociO_TEMP || this.dadosAssociado.codsocio || "",
        nomeComercial:
          cadastro.nomecomercial ||
          this.dadosAssociado.nomefantasia ||
          this.dadosAssociado.entidade ||
          "",
        email: this.obterEmailAssociadoEnvio()
      };
    },

    getOperadoraInfo() {
      const primeiroRegistro = this.relData && this.relData.length ? this.relData[0] : {};

      return {
        operadora:
          this.dadosAssociado.operadora ||
          primeiroRegistro.operadora ||
          "UNIMED - BELO HORIZONTE / COOPERATIVA DE TRABALHO MEDICO LTDA.",

        cnpj:
          this.dadosAssociado.cnpjoperadora ||
          this.dadosAssociado.cnpj ||
          "16.513.178/0001-76",

        ans:
          this.dadosAssociado.ans ||
          this.dadosAssociado.registroans ||
          "34.388-9"
      };
    },

    extractSvgSize(svgText) {
      const widthMatch = svgText.match(/\swidth=["']([\d.]+)(px)?["']/i);
      const heightMatch = svgText.match(/\sheight=["']([\d.]+)(px)?["']/i);
      const viewBoxMatch = svgText.match(/\sviewBox=["']([\d.\-\s]+)["']/i);

      let width = widthMatch ? parseFloat(widthMatch[1]) : 0;
      let height = heightMatch ? parseFloat(heightMatch[1]) : 0;

      if ((!width || !height) && viewBoxMatch) {
        const viewBoxParts = viewBoxMatch[1]
          .trim()
          .split(/\s+/)
          .map(item => parseFloat(item));

        if (viewBoxParts.length === 4) {
          width = width || viewBoxParts[2];
          height = height || viewBoxParts[3];
        }
      }

      if (!width || !height) {
        width = 360;
        height = 120;
      }

      return { width, height };
    },

    getContainSize(originalWidth, originalHeight, maxWidth, maxHeight) {
      if (!originalWidth || !originalHeight) {
        return { width: maxWidth, height: maxHeight };
      }

      const ratio = Math.min(maxWidth / originalWidth, maxHeight / originalHeight);

      return {
        width: originalWidth * ratio,
        height: originalHeight * ratio
      };
    },

    async imageUrlToBase64(url) {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Logo não encontrada.");

      const blob = await response.blob();
      const isSvg = blob.type.includes("svg") || String(url).toLowerCase().includes(".svg");

      if (isSvg) {
        const svgText = await blob.text();
        return await this.svgTextToPngBase64(svgText);
      }

      return await this.blobToBase64(blob);
    },

    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = () => {
          const dataUrl = reader.result;
          const img = new Image();

          img.onload = () => {
            resolve({
              dataUrl,
              width: img.naturalWidth || 1,
              height: img.naturalHeight || 1
            });
          };

          img.onerror = reject;
          img.src = dataUrl;
        };

        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

    svgTextToPngBase64(svgText) {
      return new Promise((resolve, reject) => {
        const size = this.extractSvgSize(svgText);
        const svgBlob = new Blob([svgText], { type: "image/svg+xml;charset=utf-8" });
        const svgUrl = URL.createObjectURL(svgBlob);
        const img = new Image();

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const width = size.width || img.naturalWidth || 360;
          const height = size.height || img.naturalHeight || 120;

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, width, height);
          ctx.drawImage(img, 0, 0, width, height);

          URL.revokeObjectURL(svgUrl);

          resolve({
            dataUrl: canvas.toDataURL("image/png"),
            width,
            height
          });
        };

        img.onerror = error => {
          URL.revokeObjectURL(svgUrl);
          reject(error);
        };

        img.src = svgUrl;
      });
    },

    async addPdfHeader(doc, y, margin, now, dadosExportacao) {
      const pageWidth = doc.internal.pageSize.getWidth();
      const headerStartY = y;
      const info = this.getOperadoraInfo();

      const dataGeracao = now.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });

      try {
        const logo = await this.imageUrlToBase64(LOGO_CDL_SAUDE_PATH);
        const maxLogoWidth = 105;
        const maxLogoHeight = 36;
        const logoSize = this.getContainSize(
          logo.width,
          logo.height,
          maxLogoWidth,
          maxLogoHeight
        );

        const logoX = margin + 8;
        const logoY = headerStartY + 4 + (maxLogoHeight - logoSize.height) / 2;

        doc.addImage(logo.dataUrl, "PNG", logoX, logoY, logoSize.width, logoSize.height);
      } catch (error) {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(21);
        doc.setTextColor(...REPORT_COLORS.blueRgb);
        doc.text("CDL", margin + 12, headerStartY + 22);
      }

      const textCenterX = pageWidth / 2 + 35;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.setTextColor(...REPORT_COLORS.blueRgb);
      doc.text("RELATÓRIO DE COPARTICIPAÇÃO", textCenterX, headerStartY + 12, {
        align: "center"
      });

      doc.setFontSize(7.8);
      doc.setTextColor(90, 90, 90);
      doc.text(
        `OPERADORA: ${String(info.operadora).toUpperCase()} |`,
        textCenterX,
        headerStartY + 28,
        { align: "center" }
      );
      doc.text(
        `CNPJ: ${info.cnpj} | ANS - Nº ${info.ans} | GERADO EM: ${dataGeracao}`,
        textCenterX,
        headerStartY + 43,
        { align: "center" }
      );

      doc.setDrawColor(...REPORT_COLORS.blueRgb);
      doc.setLineWidth(1.2);
      doc.line(margin, headerStartY + 58, pageWidth - margin, headerStartY + 58);

      const socioTexto = dadosExportacao.codSocio
        ? `SÓCIO: ${dadosExportacao.codSocio} - ${dadosExportacao.nomeComercial}`
        : `SÓCIO: ${dadosExportacao.nomeComercial}`;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(9.5);
      doc.setTextColor(...REPORT_COLORS.blueRgb);
      doc.text(String(socioTexto).toUpperCase(), margin, headerStartY + 95);

      doc.setDrawColor(...REPORT_COLORS.blueRgb);
      doc.setLineWidth(1.2);
      doc.line(margin, headerStartY + 110, pageWidth - margin, headerStartY + 110);

      return headerStartY + 120;
    },

    getPdfBaseTableStyles(fontSize) {
      return {
        theme: "grid",
        headStyles: {
          fillColor: REPORT_COLORS.lightBlueRgb,
          textColor: REPORT_COLORS.blueRgb,
          fontStyle: "bold",
          fontSize,
          halign: "center",
          lineColor: REPORT_COLORS.borderBlueRgb,
          lineWidth: 0,
          cellPadding: 5
        },
        bodyStyles: {
          textColor: REPORT_COLORS.textDarkRgb,
          fontSize,
          lineWidth: 0,
          cellPadding: 5
        },
        footStyles: {
          fillColor: REPORT_COLORS.lightBlueRgb,
          textColor: REPORT_COLORS.blueRgb,
          fontStyle: "bold",
          fontSize,
          lineWidth: 0,
          cellPadding: 5
        },
        alternateRowStyles: {
          fillColor: [252, 252, 252]
        }
      };
    },

    async gerarPdfBlob() {
      const doc = new jsPDF("p", "pt", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 40;
      const tableWidth = pageWidth - margin * 2;
      let y = 50;

      const now = new Date();
      const dataArquivo = now
        .toLocaleString("pt-BR")
        .replace(/\//g, "-")
        .replace(/:/g, "-")
        .replace(", ", "_");
      const dadosExportacao = this.getDadosAssociadoExportacao();

      y = await this.addPdfHeader(doc, y, margin, now, dadosExportacao);

      if (this.resumoPorCategoria.length > 0) {
        y = this.addTitleBluePdf(doc, y, margin, "RESUMO DE UTILIZAÇÕES", 11);

        const linhasResumo = this.resumoPorCategoria.map(item => [
          String(item.categoria || "").toUpperCase(),
          item.quantidade,
          this.$options.filters.currency(item.valor_total)
        ]);

        autoTable(doc, {
          startY: y,
          tableWidth,
          head: [[{ content: "DESCRIÇÃO DO SERVIÇO", styles: { halign: "center" } }, "QTD. TOTAL", "VLR. TOTAL"]],
          body: linhasResumo,
          foot: [
            [
              { content: "TOTAL", styles: { halign: "center" } },
              { content: this.totalResumo.quantidade, styles: { halign: "center" } },
              {
                content: this.$options.filters.currency(this.totalResumo.valor_total),
                styles: { halign: "center" }
              }
            ]
          ],
          showHead: "everyPage",
          showFoot: "lastPage",
          rowPageBreak: "avoid",
          ...this.getPdfBaseTableStyles(8),
          columnStyles: {
            0: { cellWidth: 355, halign: "left" },
            1: { cellWidth: 80, halign: "center" },
            2: { cellWidth: 80, halign: "center" }
          },
          margin: { left: margin, right: margin }
        });

        y = doc.lastAutoTable.finalY + 15;
      }

      y = this.addTitleBluePdf(doc, y, margin, "RELATÓRIO POR VIDAS", 11);

      const addPdfLabelRow = (texto) => ([
        {
          content: texto.toUpperCase(),
          colSpan: 6,
          styles: {
            fillColor: [255, 255, 255],
            textColor: REPORT_COLORS.blueRgb,
            fontStyle: "bold",
            fontSize: 9,
            halign: "left",
            cellPadding: 5
          }
        }
      ]);

      const addPdfTitularBarRow = (texto) => ([
        {
          content: texto.toUpperCase(),
          colSpan: 6,
          styles: {
            fillColor: REPORT_COLORS.blueRgb,
            textColor: REPORT_COLORS.whiteRgb,
            fontStyle: "bold",
            fontSize: 9,
            halign: "left",
            cellPadding: 7
          }
        }
      ]);

      this.gruposFamiliaSelecionados.forEach((grupo) => {
        if (y > 735) {
          doc.addPage();
          y = 50;
        }

        const linhasDoGrupo = [];

        const apenasDepend = grupo.vidas.every(v => this.normalizarTipoDependencia(v) !== "TITULAR");
        if (apenasDepend) {
          linhasDoGrupo.push(addPdfTitularBarRow(`TITULAR: ${this.getNomeTitularGrupo(grupo)}`));
        }

        grupo.vidas.forEach((vida, vidaIndex) => {
          const dtVigencia = this.obterDtVigencia(vida);
          const tipoDep = this.normalizarTipoDependencia(vida);
          const corFillVida = [84, 110, 122];
          const corTextVida = REPORT_COLORS.whiteRgb;

          if (tipoDep === "TITULAR" && vidaIndex === 0) {
            linhasDoGrupo.push(addPdfTitularBarRow(`TITULAR | ${vida.nome}`));
          }
          if (
            tipoDep === "DEPENDENTE" &&
            (vidaIndex === 0 || this.normalizarTipoDependencia(grupo.vidas[vidaIndex - 1]) === "TITULAR")
          ) {
            linhasDoGrupo.push(addPdfLabelRow("DEPENDENTE(S):"));
          }

          const textoVida = `VIDA: ${vida.nome} | CARTEIRINHA: ${vida.carteira} | DT. VIGÊNCIA: ${dtVigencia || "-"} | ${this.normalizarTipoDependencia(vida)}`;

          linhasDoGrupo.push([
            {
              content: textoVida.toUpperCase(),
              colSpan: 6,
              styles: {
                fillColor: corFillVida,
                textColor: corTextVida,
                fontStyle: "bold",
                fontSize: 8,
                halign: "left",
                cellPadding: 6
              }
            }
          ]);

          linhasDoGrupo.push([
            { content: "ATENDIMENTO", styles: { fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb, fontStyle: "bold", halign: "center" } },
            { content: "OPERADORA", styles: { fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb, fontStyle: "bold", halign: "center" } },
            { content: "SERVIÇO", styles: { fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb, fontStyle: "bold", halign: "center" } },
            { content: "QTD", styles: { fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb, fontStyle: "bold", halign: "center" } },
            { content: "UNITÁRIO", styles: { fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb, fontStyle: "bold", halign: "center" } },
            { content: "SUBTOTAL", styles: { fillColor: REPORT_COLORS.lightBlueRgb, textColor: REPORT_COLORS.blueRgb, fontStyle: "bold", halign: "center" } }
          ]);

          const usos = this.filtrarVidas(vida.codvida);
          let tQtd = 0;
          let tVlr = 0;

          usos.forEach(uso => {
            const qtd = Number(uso.quantidade) || 1;
            const valorTotal = Number(uso.vlrtotal) || 0;
            tQtd += qtd;
            tVlr += valorTotal;

            linhasDoGrupo.push([
              { content: uso.dtatendimento || uso.data || "-", styles: { halign: "center" } },
              { content: uso.operadora || "-", styles: { halign: "center" } },
              { content: String(uso.descrservico || "-").toUpperCase(), styles: { halign: "left" } },
              { content: qtd, styles: { halign: "center" } },
              { content: this.$options.filters.currency(uso.vlrunitario || 0), styles: { halign: "center" } },
              { content: this.$options.filters.currency(valorTotal), styles: { halign: "center" } }
            ]);
          });

          linhasDoGrupo.push([
            { content: "SUBTOTAL", colSpan: 3, styles: { halign: "center", fontStyle: "bold", fillColor: [252, 252, 252] } },
            { content: tQtd, styles: { halign: "center", fontStyle: "bold", fillColor: [252, 252, 252] } },
            { content: "-", styles: { halign: "center", fontStyle: "bold", fillColor: [252, 252, 252] } },
            { content: this.$options.filters.currency(tVlr), styles: { halign: "center", fontStyle: "bold", fillColor: [252, 252, 252] } }
          ]);
        });

        const totaisGrupo = this.calcularTotalUtilizacoesGrupo(grupo);
        const textoTotal = `TOTAL UTILIZAÇÕES TITULAR (${this.getNomeTitularGrupo(grupo)})`;
        const corFundoTotal = REPORT_COLORS.blueRgb;

        linhasDoGrupo.push([
          {
            content: textoTotal,
            colSpan: 5,
            styles: { fillColor: corFundoTotal, textColor: [255, 255, 255], fontStyle: "bold", halign: "left", cellPadding: 8 }
          },
          {
            content: this.$options.filters.currency(totaisGrupo.valorTotal),
            colSpan: 1,
            styles: { fillColor: corFundoTotal, textColor: [255, 255, 255], fontStyle: "bold", halign: "center", cellPadding: 8 }
          }
        ]);

        // =========================================================
        // RENDERIZANDO A TABELA ÚNICA DO GRUPO (O "CARTÃO")
        // =========================================================
        autoTable(doc, {
          startY: y,
          theme: 'grid', 
          tableWidth,
          body: linhasDoGrupo, 
          
          // --- ADICIONE ESTAS DUAS LINHAS AQUI ---
          pageBreak: 'avoid',     // Evita quebrar a tabela do grupo familiar no meio
          rowPageBreak: 'avoid',  // Evita quebrar uma única linha ao meio (textos grandes)
          // ---------------------------------------

          styles: {
            textColor: REPORT_COLORS.textDarkRgb,
            fontSize: 8,
            lineColor: REPORT_COLORS.borderBlueRgb, 
            lineWidth: 0.5, 
            cellPadding: 5
          },
          columnStyles: {
            0: { cellWidth: 70 },
            1: { cellWidth: 65 },
            2: { cellWidth: 235 },
            3: { cellWidth: 40 },
            4: { cellWidth: 50 },
            5: { cellWidth: 55 }
          },
          margin: { left: margin, right: margin }
        });

        y = doc.lastAutoTable.finalY + 30; 
      });

      if (y > 760) {
        doc.addPage();
        y = 50;
      }

      autoTable(doc, {
        startY: y,
        theme: "plain",
        tableWidth,
        body: [[`TOTAL DO ASSOCIADO: ${this.$options.filters.currency(this.total)}`]],
        bodyStyles: {
          fillColor: REPORT_COLORS.lightBlueRgb,
          textColor: REPORT_COLORS.blueRgb,
          fontStyle: "bold",
          fontSize: 11,
          halign: "center",
          cellPadding: 7
        },
        columnStyles: {
          0: { cellWidth: tableWidth }
        },
        margin: { left: margin, right: margin }
      });

      doc.setFontSize(8);
      doc.setTextColor(100, 100, 100);
      doc.text(
        "* Esse relatório não possui validade para fins de Imposto de Renda.",
        margin,
        pageHeight - 30
      );

      const nomeArquivo = `extrato_coparticipativo_LGPD_${dataArquivo}.pdf`;

      return {
        blob: doc.output("blob"),
        nomeArquivo
      };
    },

    excelBorder() {
      return {
        top: {
          style: "thin",
          color: {
            argb: REPORT_COLORS.excelBorderBlue
          }
        },
        left: {
          style: "thin",
          color: {
            argb: REPORT_COLORS.excelBorderBlue
          }
        },
        bottom: {
          style: "thin",
          color: {
            argb: REPORT_COLORS.excelBorderBlue
          }
        },
        right: {
          style: "thin",
          color: {
            argb: REPORT_COLORS.excelBorderBlue
          }
        }
      };
    },

    styleExcelMainHeader(cell, horizontal) {
      cell.font = {
        bold: true,
        size: 12,
        color: {
          argb: REPORT_COLORS.excelWhite
        }
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: REPORT_COLORS.excelBlue
        }
      };
      cell.alignment = {
        horizontal: horizontal || "center",
        vertical: "center"
      };
      cell.border = this.excelBorder();
    },

    styleExcelTableHeader(cell) {
      cell.font = {
        bold: true,
        color: {
          argb: REPORT_COLORS.excelBlue
        }
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: REPORT_COLORS.excelLightBlue
        }
      };
      cell.alignment = {
        horizontal: "center",
        vertical: "center"
      };
      cell.border = this.excelBorder();
    },

    styleExcelBodyCell(cell, horizontal) {
      cell.font = {
        color: {
          argb: REPORT_COLORS.excelDark
        }
      };
      cell.alignment = {
        horizontal: horizontal || "left",
        vertical: "center"
      };
      cell.border = this.excelBorder();
    },

    styleExcelTotalCell(cell, horizontal) {
      cell.font = {
        bold: true,
        color: {
          argb: REPORT_COLORS.excelBlue
        }
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
          argb: REPORT_COLORS.excelLightBlue
        }
      };
      cell.alignment = {
        horizontal: horizontal || "center",
        vertical: "center"
      };
      cell.border = this.excelBorder();
    },

    async gerarExcelBlob() {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("CoParticipativo LGPD");

      sheet.properties.defaultRowHeight = 20;

      const now = new Date();
      const dataAtual = now.toLocaleString("pt-BR");
      const dataArquivo = now
        .toLocaleString("pt-BR")
        .replace(/\//g, "-")
        .replace(/:/g, "-")
        .replace(", ", "_");

      const dadosExportacao = this.getDadosAssociadoExportacao();

      const setRowValues = (rowNumber, values) => {
        for (let col = 1; col <= 6; col++) {
          sheet.getCell(rowNumber, col).value = values[col - 1] !== undefined ? values[col - 1] : "";
        }
      };

      const formatMoney = cell => {
        cell.numFmt = '"R$" #,##0.00';
      };

      const formatQuantity = cell => {
        cell.numFmt = "0";
      };

      const styleRowMainHeader = (rowNumber, horizontal = "left") => {
        for (let col = 1; col <= 6; col++) {
          const cell = sheet.getCell(rowNumber, col);
          this.styleExcelMainHeader(cell, col === 1 ? horizontal : "center");
        }
      };

      const styleRowTableHeader = rowNumber => {
        for (let col = 1; col <= 6; col++) {
          this.styleExcelTableHeader(sheet.getCell(rowNumber, col));
        }
      };

      const styleRowBody = rowNumber => {
        this.styleExcelBodyCell(sheet.getCell(rowNumber, 1), "center");
        this.styleExcelBodyCell(sheet.getCell(rowNumber, 2), "center");
        this.styleExcelBodyCell(sheet.getCell(rowNumber, 3), "left");
        this.styleExcelBodyCell(sheet.getCell(rowNumber, 4), "center");
        this.styleExcelBodyCell(sheet.getCell(rowNumber, 5), "center");
        this.styleExcelBodyCell(sheet.getCell(rowNumber, 6), "center");
      };

      const styleRowTotal = rowNumber => {
        for (let col = 1; col <= 6; col++) {
          this.styleExcelTotalCell(sheet.getCell(rowNumber, col), col === 1 || col === 3 ? "left" : "center");
        }
      };

      const styleRowGroupTotal = rowNumber => {
        for (let col = 1; col <= 6; col++) {
          const cell = sheet.getCell(rowNumber, col);

          cell.font = {
            bold: true,
            color: {
              argb: REPORT_COLORS.excelWhite
            }
          };

          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: REPORT_COLORS.excelBlue
            }
          };

          cell.alignment = {
            horizontal: col === 1 ? "left" : "center",
            vertical: "center"
          };

          cell.border = this.excelBorder();
        }
      };


      let linha = 1;

      const operadoraInfo = this.getOperadoraInfo();

      setRowValues(linha, ["RELATÓRIO DE COPARTICIPAÇÃO", "", "", "", "", ""]);
      styleRowMainHeader(linha, "center");
      sheet.getCell(`A${linha}`).font.size = 16;
      sheet.mergeCells(linha, 1, linha, 6);
      linha++;

      setRowValues(linha, [`OPERADORA: ${String(operadoraInfo.operadora).toUpperCase()} |`, "", "", "", "", ""]);
      styleRowMainHeader(linha, "center");
      sheet.mergeCells(linha, 1, linha, 6);
      linha++;

      setRowValues(linha, [`CNPJ: ${operadoraInfo.cnpj} | ANS - Nº ${operadoraInfo.ans} | GERADO EM: ${dataAtual}`, "", "", "", "", ""]);
      styleRowMainHeader(linha, "center");
      sheet.mergeCells(linha, 1, linha, 6);
      linha++;

      setRowValues(linha, [`ASSOCIADO: ${dadosExportacao.codSocio} - ${dadosExportacao.nomeComercial}`, "", "", "", "", ""]);
      styleRowMainHeader(linha, "center");
      sheet.mergeCells(linha, 1, linha, 6); 
      linha++;

      setRowValues(linha, ["RESUMO DE UTILIZAÇÕES", "", "", "", "", ""]);
      styleRowMainHeader(linha, "center");
      sheet.mergeCells(linha, 1, linha, 6);
      linha++;

      setRowValues(linha, [
        "DESCRIÇÃO DO SERVIÇO",
        "",
        "",
        "",
        "QTD. TOTAL",
        "VLR. TOTAL"
      ]);
      styleRowTableHeader(linha);
      sheet.mergeCells(linha, 1, linha, 4);
      linha++;

      this.resumoPorCategoria.forEach(item => {
        setRowValues(linha, [
          String(item.categoria || "").toUpperCase(),
          "",
          "",
          "",
          Number(item.quantidade) || 0,
          Number(item.valor_total) || 0
        ]);

        styleRowBody(linha);
        sheet.mergeCells(linha, 1, linha, 4);
        sheet.getCell(linha, 1).alignment = { horizontal: "left", vertical: "center" };
        formatQuantity(sheet.getCell(`E${linha}`));
        formatMoney(sheet.getCell(`F${linha}`));

        linha++;
      });

      setRowValues(linha, [
        "TOTAL",
        "",
        "",
        "",
        Number(this.totalResumo.quantidade) || 0,
        Number(this.totalResumo.valor_total) || 0
      ]);
      styleRowTotal(linha);
      sheet.mergeCells(linha, 1, linha, 4);
      formatQuantity(sheet.getCell(`E${linha}`));
      formatMoney(sheet.getCell(`F${linha}`));
      linha++;

      setRowValues(linha, [
        "RELATÓRIO POR VIDAS",
        "",
        "",
        "",
        "",
        ""
      ]);
      styleRowMainHeader(linha, "center");
      sheet.mergeCells(linha, 1, linha, 6); 
      linha++;

      const addExcelLabelRow = (texto, rowNum) => {
        setRowValues(rowNum, [texto.toUpperCase(), "", "", "", "", ""]);
        for (let col = 1; col <= 6; col++) {
          const cell = sheet.getCell(rowNum, col);
          cell.font = { bold: true, size: 11, color: { argb: REPORT_COLORS.excelBlue } };
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: REPORT_COLORS.excelWhite } };
          cell.alignment = { horizontal: "left", vertical: "center" };
          cell.border = this.excelBorder();
        }
        sheet.mergeCells(rowNum, 1, rowNum, 6);
      };

      this.gruposFamiliaSelecionados.forEach((grupo) => {
        const addExcelTitularBarRow = (texto, rowNum) => {
          setRowValues(rowNum, [texto.toUpperCase(), "", "", "", "", ""]);
          styleRowMainHeader(rowNum, "left");
          sheet.mergeCells(rowNum, 1, rowNum, 6);
        };

        const apenasDepend = grupo.vidas.every(v => this.normalizarTipoDependencia(v) !== "TITULAR");
        if (apenasDepend) {
          addExcelTitularBarRow(`TITULAR: ${this.getNomeTitularGrupo(grupo)}`, linha);
          linha++;
        }

        grupo.vidas.forEach((vida, vidaIdx) => {
          const dtVigencia = this.obterDtVigencia(vida);
          const tipoDep = this.normalizarTipoDependencia(vida);

          if (tipoDep === "TITULAR" && vidaIdx === 0) {
            addExcelTitularBarRow(`TITULAR | ${vida.nome}`, linha);
            linha++;
          }
          if (
            tipoDep === "DEPENDENTE" &&
            (vidaIdx === 0 || this.normalizarTipoDependencia(grupo.vidas[vidaIdx - 1]) === "TITULAR")
          ) {
            addExcelLabelRow("DEPENDENTE(S):", linha);
            linha++;
          }

          const textoVida = `VIDA: ${vida.nome} | CARTEIRINHA: ${vida.carteira} | DT. VIGÊNCIA: ${dtVigencia || "-"} | ${this.normalizarTipoDependencia(vida)}`;

          setRowValues(linha, [textoVida.toUpperCase(), "", "", "", "", ""]);

          for (let col = 1; col <= 6; col++) {
            const cell = sheet.getCell(linha, col);
            cell.font = { bold: true, size: 12, color: { argb: REPORT_COLORS.excelWhite } };
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: REPORT_COLORS.excelDependente } };
            cell.alignment = { horizontal: "left", vertical: "center" };
            cell.border = this.excelBorder();
          }

          sheet.mergeCells(linha, 1, linha, 6);
          linha++;

          setRowValues(linha, [
            "ATENDIMENTO",
            "OPERADORA",
            "SERVIÇO",
            "QTD",
            "UNITÁRIO",
            "SUBTOTAL"
          ]);
          styleRowTableHeader(linha);
          linha++;

          const usos = this.filtrarVidas(vida.codvida);

          let totalQuantidadeVida = 0;
          let totalValorVida = 0;

          usos.forEach(uso => {
            const quantidade = Number(uso.quantidade) || 1;
            const valorUnitario = Number(uso.vlrunitario) || 0;
            const valorTotal = Number(uso.vlrtotal) || 0;

            totalQuantidadeVida += quantidade;
            totalValorVida += valorTotal;

            setRowValues(linha, [
              uso.dtatendimento || uso.data || "-",
              uso.operadora || "-",
              String(uso.descrservico || "-").toUpperCase(),
              quantidade,
              valorUnitario,
              valorTotal
            ]);

            styleRowBody(linha);
            formatQuantity(sheet.getCell(`D${linha}`));
            formatMoney(sheet.getCell(`E${linha}`));
            formatMoney(sheet.getCell(`F${linha}`));

            linha++;
          });

          setRowValues(linha, [
            "SUBTOTAL",
            "",
            "",
            totalQuantidadeVida,
            "-",
            totalValorVida
          ]);
          styleRowTotal(linha);
          formatQuantity(sheet.getCell(`D${linha}`));
          formatMoney(sheet.getCell(`F${linha}`));
          linha++;
        });

        const totaisGrupo = this.calcularTotalUtilizacoesGrupo(grupo);

        setRowValues(linha, [
          `TOTAL UTILIZAÇÕES TITULAR (${this.getNomeTitularGrupo(grupo)}) | ${this.$options.filters.currency(totaisGrupo.valorTotal)}`,
          "", "", "", "", ""
        ]);
        styleRowGroupTotal(linha);
        sheet.mergeCells(linha, 1, linha, 6);
        linha++;

      });

      setRowValues(linha, [
        "TOTAL DO ASSOCIADO",
        "",
        "",
        "",
        "",
        Number(this.total) || 0
      ]);
      styleRowTotal(linha);
      sheet.getCell(`A${linha}`).font.size = 12;
      formatMoney(sheet.getCell(`F${linha}`));
      linha++;

      setRowValues(linha, [
        "* Esse relatório não possui validade para fins de Imposto de Renda.",
        "",
        "",
        "",
        "",
        ""
      ]);

      for (let col = 1; col <= 6; col++) {
        const cell = sheet.getCell(linha, col);

        cell.font = {
          italic: true,
          size: 10,
          color: {
            argb: "FF666666"
          }
        };
        cell.alignment = {
          horizontal: col === 1 ? "left" : "center",
          vertical: "center"
        };
        cell.border = this.excelBorder();
      }

      sheet.columns.forEach(column => {
        let maximoTamanho = 0;

        column.eachCell({ includeEmpty: true }, cell => {
          if (!cell.isMerged && cell.value !== null && cell.value !== undefined) {
            const tamanhoTexto = cell.value.toString().length;

            if (tamanhoTexto > maximoTamanho) {
              maximoTamanho = tamanhoTexto;
            }
          }
        });

        column.width = maximoTamanho < 12 ? 12 : maximoTamanho + 2;
      });


      sheet.views = [
        {
          state: "frozen",
          ySplit: 4
        }
      ];

      // Padroniza a fonte para Arial (igual ao CDL Saúde)
      sheet.eachRow({ includeEmpty: false }, (row) => {
        row.eachCell({ includeEmpty: false }, (cell) => {
          cell.font = Object.assign({}, cell.font, { name: "Arial" });
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });

      return {
        blob,
        nomeArquivo: `extrato_coparticipativo_LGPD_${dataArquivo}.xlsx`
      };
    }
  },

  created() {
    this.getRelatorio();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";

$azul-institucional: #004E9A;
$azul-claro-fundo: #EBF2F9;
$azul-borda: #DBE9F7;
$texto-escuro: #222222;

.title-blue {
  color: $azul-institucional !important;
}

.grupo-familia-card {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  padding: 24px;
  margin-bottom: 40px;
  border: 1px solid $azul-borda;
}

.total-utilizacoes-titular-vidas {
  display: grid;
  grid-template-columns: 1fr 220px;
  align-items: center;
  gap: 0;
  width: 100%;
  background-color: $azul-institucional;
  color: #ffffff;
  border: 1px solid $azul-institucional;
  border-top: none;
  font-weight: 800;
  text-transform: uppercase;
  margin-top: 15px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.bg-vida-header {
  width: 100%;
  min-height: 34px;
  border-radius: 0;
}

.bg-vida-header-titular {
  background-color: #546E7A;
  color: #ffffff;
}

.bg-vida-header-dependente {
  background-color: #546E7A;
  color: #ffffff;
}

.vida-grupo-titular-label {
  font-weight: 800;
  font-size: 14px;
  background-color: $azul-institucional;
  color: #ffffff;
  text-transform: uppercase;
  padding: 8px 16px;
  min-height: 34px;
  display: flex;
  align-items: center;
}

.vida-grupo-dependente-label {
  font-weight: 800;
  font-size: 13px;
  color: $azul-institucional;
  text-transform: uppercase;
  padding: 14px 0 4px 0;
  border-top: 1px solid $azul-borda;
  margin-top: 12px;
}

.vida-header-text {
  font-size: 14px;
  line-height: 1.2;
}

.vida-header-card {
  font-size: 13px;
  line-height: 1.2;
}

.vida-table-shell {
  width: 100%;
  overflow-x: auto;
}

.vida-table-inner {
  width: 100%;
  min-width: 720px;
}

.lista-vida {
  width: 100%;
}

.lista-vida /deep/ table,
.vida-table-inner /deep/ table {
  width: 100% !important;
  min-width: 720px;
  margin-top: 0 !important;
  border-collapse: collapse;
}

.lista-vida /deep/ thead th,
.vida-table-inner /deep/ thead th {
  background-color: $azul-claro-fundo !important;
  color: $azul-institucional !important;
  border: 1px solid $azul-borda !important;
  font-weight: 800;
  text-transform: uppercase;
  vertical-align: middle;
}

.lista-vida /deep/ tbody td,
.vida-table-inner /deep/ tbody td {
  border: 1px solid $azul-borda !important;
  color: $texto-escuro;
  vertical-align: middle;
}

.lista-vida /deep/ tfoot td,
.vida-table-inner /deep/ tfoot td,
::v-deep .lista-vida tfoot td,
::v-deep .vida-table-inner tfoot td {
  background-color: $azul-claro-fundo !important;
  color: $azul-institucional !important;
  border: 1px solid $azul-borda !important;
  font-weight: 800;
}

.lista-vida /deep/ tfoot td:first-child,
.vida-table-inner /deep/ tfoot td:first-child,
::v-deep .lista-vida tfoot td:first-child,
::v-deep .vida-table-inner tfoot td:first-child {
  position: relative !important;
  color: transparent !important;
  font-size: 0 !important;
}

.lista-vida /deep/ tfoot td:first-child *,
.vida-table-inner /deep/ tfoot td:first-child *,
::v-deep .lista-vida tfoot td:first-child *,
::v-deep .vida-table-inner tfoot td:first-child * {
  color: transparent !important;
  font-size: 0 !important;
}

.lista-vida /deep/ tfoot td:first-child::before,
.vida-table-inner /deep/ tfoot td:first-child::before,
::v-deep .lista-vida tfoot td:first-child::before,
::v-deep .vida-table-inner tfoot td:first-child::before {
  content: "SUBTOTAL:" !important;
  color: #000000 !important;
  font-size: 0.8rem !important;
  font-weight: 800 !important;
}

.vida-grupo-shell {
  width: 100%;
}

.vida-table-shell+.vida-table-shell .vida-header-colado {
  margin-top: 0 !important;
}

.vida-table-shell+.vida-table-shell .vida-table-inner {
  margin-top: 0 !important;
}

.vida-table-shell+.vida-table-shell {
  margin-top: 0 !important;
}

.lista-vida /deep/ table,
.vida-table-inner /deep/ table,
::v-deep .lista-vida table,
::v-deep .vida-table-inner table {
  margin-bottom: 0 !important;
}

.total-utilizacoes-titular-vidas>div {
  padding: 10px 12px;
  border-right: 1px solid $azul-borda;
}

.total-utilizacoes-titular-vidas>div:last-child {
  border-right: none;
}

.total-utilizacoes-titular-qtd,
.total-utilizacoes-titular-valor {
  text-align: center;
}

.bg-vida-total {
  background-color: $azul-claro-fundo;
  color: $azul-institucional;
}

.gap-2 {
  gap: 0.5rem;
}

.table-resumo {
  border: 1px solid $azul-borda;

  .thead-blue th {
    background-color: $azul-claro-fundo;
    color: $azul-institucional;
    font-weight: 800;
    font-size: 13px;
    border: 1px solid $azul-borda;
    vertical-align: middle;
    text-transform: uppercase;
  }

  td {
    color: $texto-escuro;
    font-weight: 500;
    font-size: 13px;
    text-transform: uppercase;
    border: 1px solid $azul-borda;
    vertical-align: middle;
  }

  .tfoot-light-blue td {
    background-color: $azul-claro-fundo;
    color: $azul-institucional;
    font-weight: 800;
    border: 1px solid $azul-borda;
  }
}

.message-box {
  display: flex;
  background-color: #f8f9fa;
  padding: 20px;
  margin-bottom: 20px;
  width: calc(100% - 20px);
}

.alert {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
}

.message {
  margin: 0;
  padding: 5px 0;
}

.report-logo {
  width: 200px;
  height: auto;
  margin-right: 0;
  mix-blend-mode: multiply;
}

.vidas-lista /deep/ {
  .v-select {
    .vs__dropdown-toggle {
      border-radius: 6px;
      background: white;
      border-bottom: none !important;
      height: 45px;
      display: flex;
      align-items: center;
      position: relative;

      .vs__selected {
        position: absolute;
        left: 10px;
        top: 14px;
      }

      .vs__selected-options {
        width: calc(100% - 40px);

        input {
          width: 100%;
          border: none;
          height: 40px;
          padding: 5px 15px;
        }
      }

      .vs__actions {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        cursor: pointer;

        .vs__clear {
          background: transparent;
          border: none;
          margin-left: -20px;
          margin-right: 10px;
        }
      }
    }

    .vs__dropdown-menu {
      background: white;
      border: none;
      padding: 10px;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;

      li {
        padding-top: 5px;
        padding-bottom: 5px;
        cursor: pointer;

        &:hover {
          color: black;
          font-weight: 700;
        }
      }
    }

    &.vs--open {
      .vs__dropdown-toggle {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
}

.vidas-lista /deep/ .vs--searching .vs__selected,
.vidas-lista /deep/ .vs--open .vs__selected,
::v-deep .vidas-lista .vs--searching .vs__selected,
::v-deep .vidas-lista .vs--open .vs__selected {
  display: none !important;
}

.vidas-lista /deep/ .vs__search,
::v-deep .vidas-lista .vs__search {
  min-width: 100% !important;
}

.vidas-lista /deep/ .vs__selected-options,
::v-deep .vidas-lista .vs__selected-options {
  overflow: hidden;
}

.btn-voltar {
  color: $azul-institucional;
  font-weight: 700;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
}

.title {
  font-weight: 700;
  font-size: 22px;
}

.flex-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-weight: 900;
  text-align: left;
}

h3.subtitle {
  font-size: 1.4rem;
  font-weight: 700;
  color: $azul-institucional;
}

.rel-value {
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  color: #000;
}

.rel-title {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 10px;
}

.rel-value-reg {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}

#relcontainer table {
  width: 100%;
  margin-top: 0;
}

td {
  font-size: 0.8rem;
}

.rel-block {
  width: 100%;
  border-radius: 5px 0;
  background: #fff;
  margin: 25px 15px 15px 15px;
}

.modal-envio-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.modal-envio-card {
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.modal-envio-header {
  background: $azul-institucional;
  color: #ffffff;
  padding: 14px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h5 {
    margin: 0;
    font-weight: 800;
    text-transform: uppercase;
    font-size: 16px;
  }
}

.modal-envio-close {
  border: none;
  background: transparent;
  color: #ffffff;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  font-weight: 700;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.modal-envio-body {
  padding: 20px;
  color: #222222;
  font-size: 14px;
}

.modal-envio-footer {
  padding: 14px 18px;
  background: #f8f9fa;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";

$azul-institucional: #004E9A;
$azul-claro-fundo: #EBF2F9;
$azul-borda: #DBE9F7;
$texto-escuro: #222222;

.title-blue {
  color: $azul-institucional !important;
}

/* NOVA CLASSE: Cria o bloco com sombra para o grupo familiar */
.grupo-familia-card {
  background-color: #ffffff;
  border-radius: 12px;
  /* Arredonda as pontas do bloco */
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  /* Cria a sombra suave em volta */
  padding: 24px;
  /* Espaçamento interno para a tabela não grudar nas bordas */
  margin-bottom: 40px;
  /* Cria um distanciamento bem claro entre um grupo familiar e o próximo */
  border: 1px solid $azul-borda;
  /* Linha super sutil acompanhando a sombra */
}

/* APAGUE A CLASSE ANTIGA: .vida-grupo-separador { ... } e substitua por nada, pois removemos ela */

/* ATUALIZE A CLASSE EXISTENTE PARA ARREDONDAR OS CANTOS: */
.total-utilizacoes-titular-vidas {
  display: grid;
  grid-template-columns: 1fr 220px;
  align-items: center;
  gap: 0;
  width: 100%;
  background-color: $azul-institucional;
  color: #ffffff;
  border: 1px solid $azul-institucional;
  border-top: none;
  font-weight: 800;
  text-transform: uppercase;
  margin-top: 15px;
  /* Adiciona uma folguinha acima do totalizador */

  /* Novas linhas para acompanhar o formato do bloco: */
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.bg-vida-header {
  width: 100%;
  min-height: 34px;
  border-radius: 0;
}

.bg-vida-header-titular {
  background-color: #546E7A;
  color: #ffffff;
}

.bg-vida-header-dependente {
  background-color: #546E7A;
  color: #ffffff;
}

.vida-grupo-titular-label {
  font-weight: 800;
  font-size: 14px;
  background-color: $azul-institucional;
  color: #ffffff;
  text-transform: uppercase;
  padding: 8px 16px;
  min-height: 34px;
  display: flex;
  align-items: center;
}

.vida-grupo-dependente-label {
  font-weight: 800;
  font-size: 13px;
  color: $azul-institucional;
  text-transform: uppercase;
  padding: 14px 0 4px 0;
  border-top: 1px solid $azul-borda;
  margin-top: 12px;
}

.vida-header-text {
  font-size: 14px;
  line-height: 1.2;
}

.vida-header-card {
  font-size: 13px;
  line-height: 1.2;
}

.vida-table-shell {
  width: 100%;
  overflow-x: auto;
}

.vida-table-inner {
  width: 100%;
  min-width: 720px;
}

.lista-vida {
  width: 100%;
}

.lista-vida /deep/ table,
.vida-table-inner /deep/ table {
  width: 100% !important;
  min-width: 720px;
  margin-top: 0 !important;
  border-collapse: collapse;
}

.lista-vida /deep/ thead th,
.vida-table-inner /deep/ thead th {
  background-color: $azul-claro-fundo !important;
  color: $azul-institucional !important;
  border: 1px solid $azul-borda !important;
  font-weight: 800;
  text-transform: uppercase;
  vertical-align: middle;
}

.lista-vida /deep/ tbody td,
.vida-table-inner /deep/ tbody td {
  border: 1px solid $azul-borda !important;
  color: $texto-escuro;
  vertical-align: middle;
}

.lista-vida /deep/ tfoot td,
.vida-table-inner /deep/ tfoot td,
::v-deep .lista-vida tfoot td,
::v-deep .vida-table-inner tfoot td {
  background-color: $azul-claro-fundo !important;
  color: $azul-institucional !important;
  border: 1px solid $azul-borda !important;
  font-weight: 800;
}

.lista-vida /deep/ tfoot td:first-child,
.vida-table-inner /deep/ tfoot td:first-child,
::v-deep .lista-vida tfoot td:first-child,
::v-deep .vida-table-inner tfoot td:first-child {
  position: relative !important;
  color: transparent !important;
  font-size: 0 !important;
}

.lista-vida /deep/ tfoot td:first-child *,
.vida-table-inner /deep/ tfoot td:first-child *,
::v-deep .lista-vida tfoot td:first-child *,
::v-deep .vida-table-inner tfoot td:first-child * {
  color: transparent !important;
  font-size: 0 !important;
}

.lista-vida /deep/ tfoot td:first-child::before,
.vida-table-inner /deep/ tfoot td:first-child::before,
::v-deep .lista-vida tfoot td:first-child::before,
::v-deep .vida-table-inner tfoot td:first-child::before {
  content: "SUBTOTAL:" !important;
  color: #000000 !important;
  font-size: 0.8rem !important;
  font-weight: 800 !important;
}

.vida-grupo-shell {
  width: 100%;
}

.vida-table-shell+.vida-table-shell .vida-header-colado {
  margin-top: 0 !important;
}

.vida-table-shell+.vida-table-shell .vida-table-inner {
  margin-top: 0 !important;
}

.vida-table-shell+.vida-table-shell {
  margin-top: 0 !important;
}

.lista-vida /deep/ table,
.vida-table-inner /deep/ table,
::v-deep .lista-vida table,
::v-deep .vida-table-inner table {
  margin-bottom: 0 !important;
}

.vida-grupo-separador {
  width: 100%;
  height: 1px;
  background-color: $azul-institucional;
}

.total-utilizacoes-titular-vidas {
  display: grid;
  grid-template-columns: 1fr 220px;
  align-items: center;
  gap: 0;
  width: 100%;
  background-color: $azul-institucional;
  color: #ffffff;
  border: 1px solid $azul-institucional;
  border-top: none;
  font-weight: 800;
  text-transform: uppercase;
}

.total-utilizacoes-titular-vidas>div {
  padding: 10px 12px;
  border-right: 1px solid $azul-borda;
}

.total-utilizacoes-titular-vidas>div:last-child {
  border-right: none;
}

.total-utilizacoes-titular-qtd,
.total-utilizacoes-titular-valor {
  text-align: center;
}

.vida-grupo-separador-fim {
  margin: 28px 0 28px 0;
}

.bg-vida-total {
  background-color: $azul-claro-fundo;
  color: $azul-institucional;
}

.gap-2 {
  gap: 0.5rem;
}

.table-resumo {
  border: 1px solid $azul-borda;

  .thead-blue th {
    background-color: $azul-claro-fundo;
    color: $azul-institucional;
    font-weight: 800;
    font-size: 13px;
    border: 1px solid $azul-borda;
    vertical-align: middle;
    text-transform: uppercase;
  }

  td {
    color: $texto-escuro;
    font-weight: 500;
    font-size: 13px;
    text-transform: uppercase;
    border: 1px solid $azul-borda;
    vertical-align: middle;
  }

  .tfoot-light-blue td {
    background-color: $azul-claro-fundo;
    color: $azul-institucional;
    font-weight: 800;
    border: 1px solid $azul-borda;
  }
}

.message-box {
  display: flex;
  background-color: #f8f9fa;
  padding: 20px;
  margin-bottom: 20px;
  width: calc(100% - 20px);
}

.alert {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
}

.message {
  margin: 0;
  padding: 5px 0;
}

.report-logo {
  width: 200px;
  height: auto;
  margin-right: 0;
  mix-blend-mode: multiply;
}

.vidas-lista /deep/ {
  .v-select {
    .vs__dropdown-toggle {
      border-radius: 6px;
      background: white;
      border-bottom: none !important;
      height: 45px;
      display: flex;
      align-items: center;
      position: relative;

      .vs__selected {
        position: absolute;
        left: 10px;
        top: 14px;
      }

      .vs__selected-options {
        width: calc(100% - 40px);

        input {
          width: 100%;
          border: none;
          height: 40px;
          padding: 5px 15px;
        }
      }

      .vs__actions {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        cursor: pointer;

        .vs__clear {
          background: transparent;
          border: none;
          margin-left: -20px;
          margin-right: 10px;
        }
      }
    }

    .vs__dropdown-menu {
      background: white;
      border: none;
      padding: 10px;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;

      li {
        padding-top: 5px;
        padding-bottom: 5px;
        cursor: pointer;

        &:hover {
          color: black;
          font-weight: 700;
        }
      }
    }

    &.vs--open {
      .vs__dropdown-toggle {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
}

.vidas-lista /deep/ .vs--searching .vs__selected,
.vidas-lista /deep/ .vs--open .vs__selected,
::v-deep .vidas-lista .vs--searching .vs__selected,
::v-deep .vidas-lista .vs--open .vs__selected {
  display: none !important;
}

.vidas-lista /deep/ .vs__search,
::v-deep .vidas-lista .vs__search {
  min-width: 100% !important;
}

.vidas-lista /deep/ .vs__selected-options,
::v-deep .vidas-lista .vs__selected-options {
  overflow: hidden;
}

.btn-voltar {
  color: $azul-institucional;
  font-weight: 700;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
}

.title {
  font-weight: 700;
  font-size: 22px;
}

.flex-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-weight: 900;
  text-align: left;
}

h3.subtitle {
  font-size: 1.4rem;
  font-weight: 700;
  color: $azul-institucional;
}

.rel-value {
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  color: #000;
}

.rel-title {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 10px;
}

.rel-value-reg {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}

#relcontainer table {
  width: 100%;
  margin-top: 0;
}

td {
  font-size: 0.8rem;
}

.rel-block {
  width: 100%;
  border-radius: 5px 0;
  background: #fff;
  margin: 25px 15px 15px 15px;
}

.modal-envio-backdrop {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.modal-envio-card {
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.modal-envio-header {
  background: $azul-institucional;
  color: #ffffff;
  padding: 14px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h5 {
    margin: 0;
    font-weight: 800;
    text-transform: uppercase;
    font-size: 16px;
  }
}

.modal-envio-close {
  border: none;
  background: transparent;
  color: #ffffff;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  font-weight: 700;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

.modal-envio-body {
  padding: 20px;
  color: #222222;
  font-size: 14px;
}

.modal-envio-footer {
  padding: 14px 18px;
  background: #f8f9fa;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
